import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Address, Order } from '@ct-client';
import { countries } from 'countries-list';

@Injectable({
    providedIn: 'root'
})
export class AddressHelperService {

    constructor(public translate: TranslateService) { }

    public getAddressString(address: Address): string {
        if (!address) {
            return '';
        }

        const street = address.sAddr ? `${address.sAddr}${address.nNumber ? ` ${address.nNumber}, ` : ', '}` : '';
        const post = address.sPost || '';
        const country = address.sCtryCode
            ? countries[address.sCtryCode]?.name
            : address.sCtry
                ? countries[address.sCtry]?.name
                : '-';

        return `${street}${post} ${address.sCity} - ${country}`;
    }

    public getAddressStringNoCountryParse(address: Address): string {
        if (!address) {
            return '';
        }

        const locaName = address.sLocaName ? `${address.sLocaName} | ` : '';
        const street = address.sAddr ? `${address.sAddr}${address.nNumber ? ` ${address.nNumber}, ` : ', '}` : '';
        const post = address.sPost || '';
        const country = address.sCtryCode
            ? countries[address.sCtryCode]?.name
            : address.sCtry
                ? address.sCtry
                : '-';

        return `${locaName}${street}${post} ${address.sCity} - ${country}`;
    }

    public getLoggedOutAddressString(address: Address): string {
        if (!address) {
            return '';
        }

        const post = address.sPost ? `${address.sPost} ` : '';
        const city = address.sCity || '';
        let country = '-';

        if (address.sCtryCode) {
            country = countries[address.sCtryCode]?.name || address.sCtryCode;
        } else if (address.sCtry) {
            country = countries[address.sCtry]?.name || address.sCtry;
        }

        return `${post}${city} - ${country}`;
    }

    public getCollectionsTooltip(order: any, isMaterialOrderMode: boolean) {
        let tooltip = this.getAddressStringNoCountryParse(isMaterialOrderMode ?
            order.jOrigLoca : order.collectionLocation[0]);
        if (order.collectionLocation && order.collectionLocation.length > 1) {
            tooltip += `\n\n${order.collectionLocation.length} ${this.translate.instant('generic_collection_locations')}`;
        }

        return tooltip;
    }

    public getCollectionsText(order: any, isMaterialOrderMode: boolean) {
        let text = order.collectionLocation && order.collectionLocation.length > 1 ?
            `(1/${order.collectionLocation.length}) ` :
            '';

        text += this.getAddressStringNoCountryParse(
            isMaterialOrderMode ?
                order.jOrigLoca :
                order.collectionLocation[0]
        );

        return text;
    }

    public getDeliveriesText(order: any, isMaterialOrderMode: boolean) {
        let text = order.deliveryLocation && order.deliveryLocation.length > 1 ?
            `(1/${order.deliveryLocation.length}) ` :
            '';

        text += this.getAddressStringNoCountryParse(
            isMaterialOrderMode ?
                order.jDestLoca :
                order.deliveryLocation[order.deliveryLocation.length - 1]
        );

        return text;
    }

    public getDeliveriesTooltip(order: any, isMaterialOrderMode: boolean) {
        let tooltip = this.getAddressStringNoCountryParse(isMaterialOrderMode ?
            order.jDestLoca : order.deliveryLocation[order.deliveryLocation.length - 1]);
        if (order.deliveryLocation && order.deliveryLocation.length > 1) {
            tooltip += `\n\n${order.deliveryLocation.length} ${this.translate.instant('generic_delivery_locations')}`;
        }
        return tooltip;
    }

    public getTotalStops(order: Order) {
        let text = order.stops && order.stops.length.toString();
        if (order.stops && order.stops.length > 2) {
            text += order.deliveryLocation.length > 1 ?
                ` (${order.deliveryLocation.length} ${this.translate.instant('generic_deliveries_small')})` :
                ` (${order.collectionLocation.length} ${this.translate.instant('generic_collections_small')})`;
        }
        return text;
    }

}
